import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import { addSubscription, getSubscription } from '../../feature/subscription/subscriptionSlice';

// import { currencyList } from '../../constant/Constatnt';

const activities = [
    { key: "1", label: "Photo", },
    { key: "2", label: "Video", },
    { key: "3", label: "Learning", },
    { key: "4", label: "Meal", },
    { key: "5", label: "Nap", },
    { key: "6", label: "Bathroom", },
    { key: "7", label: "Bottle", },
    { key: "8", label: "Mood", },
    { key: "9", label: "Meds", },
    { key: "10", label: "Note", },
];

const rooms = [
    { key: 1, label: "Rainbow Room " },
    { key: 2, label: "Dream Room" },
    { key: 3, label: "Magic Room" },
    { key: 4, label: "Daisy Room" },
]
const children = [
    { key: 1, label: "Alexander 1" },
    { key: 2, label: "Alexander 2" },
    { key: 3, label: "Alexander 3" },
    { key: 4, label: "Alexander 4" },
]

function AddSubscription() {

    const { actionLoader } = useSelector((state) => state.subscriptions);


    const [form] = Form.useForm();

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()


    const onFinish = async (values) => {
        const resultAction = await dispatch(addSubscription(values));
        if (addSubscription.fulfilled.match(resultAction)) {
            await dispatch(getSubscription({}));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("Add subscription");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };


    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}

        >
            <Form.Item
                name="planName"
                label="Plan Name"
                rules={[{ required: true, message: 'Please enter plan name' }]}
            >
                <Input placeholder="Enter Plan Name" size='large' />
            </Form.Item>
            <Form.Item
                name="durationInMonths"
                label="Duration"
                rules={[{ required: true, message: 'Please enter duration in months ' }]}
            >
                <Input placeholder='Duration' suffix="Months" />
            </Form.Item>
            <Form.Item
                name="price"
                label="Price"
                rules={[{ required: true, message: 'Please enter price' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter Price" size='large' />
            </Form.Item>
            <Form.Item
                name="numberOfAdmins"
                label="Admin"
                rules={[{ required: true, message: 'Please enter number Of admins' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter No. Of Admin" size='large' />
            </Form.Item>
            <Form.Item
                name="numberOfChildrens"
                label="Children"
                rules={[{ required: true, message: 'Please enter number Of childrens' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter No. Of Childrens" size='large' />
            </Form.Item>
            <Form.Item
                name="numberOfTeachers"
                label="Teacher"
                rules={[{ required: true, message: 'Please enter number Of teachers' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter No. Of Teachers" size='large' />
            </Form.Item>
            {/* Description */}
            <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true, message: 'Please enter description' }]}
            >
                <Input.TextArea placeholder="Enter description..." />
            </Form.Item>
            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const AddProps = {
        open,
        setOpen,
        title: 'Add New Subscription',
        action: 'Add',
        content: AddForm,
    };

    return (
        <section>
            <AddDrawer {...AddProps} />
        </section>
    );
}



export default AddSubscription